<template>
  <div class="actions" @mouseleave="fecharSubmenu">
    <div @click.stop>
      <div @mouseenter="abrirSubmenuRemessa" class="menu-remessa">
        <span>Remessa</span>
      </div>

      <div v-show="submenuAberto" class="submenu">
        <div @click.stop="abrirModalRemessa()" class="submenu-item">
          <span>Nova Publicação</span>
        </div>
        <div v-if="protocolo !== undefined" @click.stop="abrirModalProtocolo()" class="submenu-item">
          <span>Protocolo</span>
        </div>
        <div @click.stop="abrirModalExclusao()" class="submenu-item">
          <span>Cancelar</span>
        </div>
      </div>
    </div>

    <v-dialog v-model="mostrarDialogRemessa" persistent max-width="500">
      <v-card>
        <v-card-title class="modal-header">
          <h3>Envio de Remessa de Documentos</h3>
        </v-card-title>

        <v-card-text>
          <div class="document-list">
            <table class="styled-table">
              <thead>
              <tr>
                <th>
                  <input
                      type="checkbox"
                      @change="selecionarTodos($event)"
                      ref="selecionarTodosCheckbox"
                  />
                </th>
                <th>Documentos</th>
                <th>Criação</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(anexo, index) in anexos" :key="index">
                <td>
                  <input
                      type="checkbox"
                      :checked="anexo.isSelected"
                      @change="selecionarDocumento($event, anexo)"
                  />
                </td>
                <td>{{ anexo.arquivoNome }}</td>
                <td>{{ anexo.dataHoraCadastro | az-date('DD/MM/YYYY HH:mm:ss') }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </v-card-text>

        <v-card-actions class="modal-footer">
          <button
              class="btn cancel"
              @click="fecharModalRemessa"
          >
            CANCELAR
          </button>
          <button
              class="btn submit"
              :disabled="!documentosSelecionados.length"
              @click="confirmarEnvio"
          >
            ENVIAR
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarDialogExclusao" persistent max-width="500">
      <v-card style="border-radius: 16px">
        <v-card-text style="text-align: center; display: flex; flex-direction: column; align-items: center; gap: 16px;">
          <v-icon class="icon-alert-pncp" color="orange" aria-hidden="true" style="font-size: 81px;">warning</v-icon>

          <p style="font-size: 24px; font-weight: bold; margin: 0; color: #696868">
            Atenção! Você está prestes a cancelar o envio da Remessa!
          </p>

          <p style="margin: 0; font-size: 18px; color: #7a7979;">
            Após a confirmação os dados enviados serão cancelados!
          </p>

          <p style="margin: 0; font-size: 18px; color: #7a7979;">
            Deseja realmente confirmar esta ação?
          </p>
        </v-card-text>

        <v-card-actions style="justify-content: center; padding: 16px; gap: 16px;">
          <button
              class="btn cancel btn-excluir"
              @click="cancelarModalExclusao"
          >
            NÃO
          </button>
          <button
              class="btn submit btn-excluir"
              @click="confirmarExclusao"
          >
            SIM
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mostrarDialogProtocolo" persistent max-width="500">
      <v-card>
        <v-card-title class="modal-header">
          <h3>Número de Protocolo</h3>
        </v-card-title>
          <v-card-text>
            <div>
              <label for="protocolo">Número de Protocolo: </label>
              <span>{{ protocolo }}</span>
            </div>
          </v-card-text>
          <v-card-actions class="modal-footer">
            <button
                class="btn cancel btn-excluir"
                @click="fecharModalProtocolo"
            >
              FECHAR
            </button>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { actionTypes } from "@/commons/constants";

export default {
  name: "LicitacaoAtualizacaoAcoesRemessa",
  data() {
    return {
      mostrarDialogRemessa: false,
      mostrarDialogProtocolo: false,
      submenuAberto: false,
      numeracao: this.numProcesso + this.numeroEdital,
      anexos: [], // Lista de documentos
      documentosSelecionados: [], // IDs dos documentos selecionados
      licitacaoId: undefined,
      mostrarDialogExclusao: false,
      protocolo: undefined
    };
  },
  props: {
    numProcesso: {
      type: String,
      default: "",
    },
    numeroEdital: {
      type: String,
      default: "",
    },
  },
  methods: {

    abrirSubmenuRemessa() {
      this.submenuAberto = !this.submenuAberto;
    },
    fecharSubmenu() {
      this.submenuAberto = false;
    },
    abrirModalRemessa() {
      this.buscarDocumentosNaoEnviados(this.licitacao.id);
      this.mostrarDialogExclusao = false;
      this.mostrarDialogProtocolo = false;
      this.mostrarDialogRemessa = true;
    },
    abrirModalExclusao() {
      this.mostrarDialogRemessa = false;
      this.mostrarDialogProtocolo = false;
      this.mostrarDialogExclusao = true;
    },
    abrirModalProtocolo() {
      this.mostrarDialogExclusao = false;
      this.mostrarDialogRemessa = false;
      this.mostrarDialogProtocolo = true;
    },
    confirmarExclusao() {
      this.excluirPrepublicacao(this.licitacao.id).then(response => {
        if (response.error) {
          this.mostrarNotificacaoErro(response.message)
        } else {
          this.mostrarNotificacaoSucessoDefault()
        }
      }).finally(() => {
        this.cancelarModalExclusao()
      })
    },
    cancelarModalExclusao() {
      this.mostrarDialogExclusao = false;
    },
    fecharModalRemessa() {
      this.anexos = [];
      this.documentosSelecionados = [];
      this.mostrarDialogRemessa = false;
      this.$refs.selecionarTodosCheckbox.checked = false;
    },
    fecharModalProtocolo() {
      this.mostrarDialogProtocolo = false;
    },
    confirmarEnvio() {
      let payload = this.montarObjeto()
      this.novaPrePublicacao(payload).then(response => {
        if (response.error) {
          this.mostrarNotificacaoErro(response.message)
        } else {
          this.mostrarNotificacaoSucessoDefault()
        }
      }).finally(() => {
        this.fecharModalRemessa();
      })
    },

    montarObjeto() {
      return {
          licitacaoId: this.licitacao.id,
          documentos: this.anexos.filter(anexo => this.documentosSelecionados.includes(anexo.id)).map(anexo => {
                return {
                  entidadeId: anexo.id,
                  licitacaoId: anexo.licitacaoId,
                  entidadeNome: anexo.entidadeNome
                }
              }
          )
      }
    },

    selecionarTodos(event) {
      const isChecked = event.target.checked;
      this.anexos.forEach((anexo) => {
        anexo.isSelected = isChecked;
      });

      this.documentosSelecionados = isChecked
          ? this.anexos.map((anexo) => anexo.id)
          : [];
    },

    selecionarDocumento(event, anexo) {
      anexo.isSelected = event.target.checked;

      if (anexo.isSelected) {
        if (!this.documentosSelecionados.includes(anexo.id)) {
          this.documentosSelecionados.push(anexo.id);
        }
      } else {
        this.documentosSelecionados = this.documentosSelecionados.filter(
            (id) => id !== anexo.id
        );
      }

      // Atualiza o estado do checkbox "Selecionar Todos"
      const todosSelecionados = this.anexos.every(
          (anexo) => anexo.isSelected
      );
      this.$refs.selecionarTodosCheckbox.checked = todosSelecionados;
    },

    async buscarDocumentosNaoEnviados(licitacaoId) {
      const data = await this.buscarDocumentosRemessa(licitacaoId);
      this.anexos = data.items;
      this.anexos.forEach((anexo) => {
        anexo.isSelected = false;
      });
    },
    ...mapActions([
        actionTypes.BUSCAR_DOCUMENTOS_REMESSA,
        actionTypes.EXCLUIR_PREPUBLICACAO,
        actionTypes.NOVA_PREPUBLICACAO,
        actionTypes.BUSCAR_PROCOTOLO,
    ]),
  },
  computed: {
    ...mapState(["loki", "parametros", "licitacao"]),
  },
  async mounted() {
    let payload = {
      licitacaoId: this.$route.params.id,
      operacao: "prepublicacao"
    };

    const response = await this.buscarProtocoloEsfinge(payload)
    if(response !== "") {
      this.protocolo = response
    } else {
      this.protocolo = undefined
    }

    this.$root.$on("menu-principal-fechado", this.fecharSubmenu);
  },
  beforeDestroy() {
    this.$root.$off("menu-principal-fechado", this.fecharSubmenu);
  },
};
</script>

<style>
.modal-header {
  background-color: #0067a5;
  color: white;
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.document-list {
  margin-top: 16px;
  overflow-x: auto;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  margin: 10px 0;
  box-shadow: none;
}

.styled-table thead tr {
  background-color: #f5f5f5;
  color: #333;
  font-weight: bold;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: left;
  border: 1px solid #ddd;
}

.styled-table tbody tr:hover {
  background-color: #f9f9f9;
}

.styled-table input[type="checkbox"] {
  margin: 0 auto;
  display: block;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}

.modal-footer-excluir {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: #f9f9f9;
  border-top: 1px solid #ddd;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn.cancel {
  background: #0067a5;
  color: #fff;
  font-weight: bold;
}

.btn.submit {
  background: #fff;
  color: #0067a5;
  font-weight: bold;
}

.btn.submit:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-excluir {
    padding: 6px 32px;
    border: 1px solid #0067a5;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.modal-header {
  background-color: #0067a5;
  color: white;
  padding: 16px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.document-list {
  margin-top: 16px;
  overflow-x: auto;
}

.document-list table {
  width: 100%;
  border-collapse: collapse;
}

.document-list th,
.document-list td {
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
  font-size: 14px;
}

.document-list th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-transform: uppercase;
}

.document-list td input[type="checkbox"] {
  margin: 0;
  display: inline-block;
}

.menu-remessa {
  padding: 15px;
  cursor: pointer;
}

.submenu {
  display: flex;
  flex-direction: column;
  margin-left: 15px;
  margin-right: 15px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 1em;
}

.submenu-item {
  margin: 5px 0;
  padding: 10px;
  transition: background-color 0.2s;
  cursor: pointer;
}

.submenu-item:hover {
  background-color: #e0e0e0;
  border-radius: 3px;
}
</style>
